/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Typography2 } from '@coursera/cds-core';

import _t from 'i18n!nls/xdp';

const styles = {
  container: css`
    &::before {
      content: '';
      position: absolute;
      left: 0;
      right: 0;
      bottom: 100%;
      height: 48px;
      pointer-events: none;
      background: linear-gradient(to bottom, transparent 0%, var(--cds-color-neutral-background-primary) 100%);
      z-index: 0;
      border-radius: inherit;
      display: block;
    }
  `,
  containerExpanded: css`
    padding-top: 0;

    &::before {
      display: none;
    }
  `,
};

// Not customizable, the implementation has not been typed yet so its defined here.
type ToggleButtonForTogglableContentProps = {
  collapsed: boolean;
};

const ToggleButtonForTogglableContentBackground = ({ collapsed }: ToggleButtonForTogglableContentProps) => {
  return (
    <div css={[styles.container, !collapsed && styles.containerExpanded]}>
      <Typography2 variant="subtitleMedium" component="span">
        {collapsed ? _t('Read more') : _t('Read less')}
      </Typography2>
    </div>
  );
};

export default ToggleButtonForTogglableContentBackground;
